/* Scope promotional-overlay dismissal to FEINE. Never touch age, cart or payment dialogs. */
/* Repeat gallery benefits while visible, with no tap action or playback icon. */
(()=>{
 if(!document.body.classList.contains('feine-pdp'))return;
 document.querySelectorAll('[data-feine-rotation]').forEach(root=>{
  if(root.dataset.initialized)return;root.dataset.initialized='true';
  const word=root.querySelector('[data-rotation-word]');if(!word)return;
  const mobile=root.hasAttribute('data-mobile-benefits');
  const labels=mobile?['STAY ALERT.','STAY FOCUSED.','HANDS FREE.','KEEP GOING.']:['MORE ALERT.','MORE FOCUSED.','HANDS FREE.'],motion=matchMedia('(prefers-reduced-motion: reduce)');
  let index=0,timer,visible=false;
  function sync(){
   clearTimeout(timer);
   if(motion.matches){word.getAnimations?.().forEach(a=>a.cancel());index=mobile?0:2;word.textContent=labels[index];return}
   if(visible&&!document.hidden&&root.getClientRects().length)timer=setTimeout(advance,2600);
  }
  function advance(){
   index=(index+1)%labels.length;word.textContent=labels[index];
   word.animate?.([{opacity:0,transform:'translateY(4px)'},{opacity:1,transform:'translateY(0)'}],{duration:200,easing:'ease-out'});
   sync();
  }
  motion.addEventListener('change',sync);document.addEventListener('visibilitychange',sync);
  if('IntersectionObserver' in window)new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync()}).observe(root);else visible=true;
  sync();
 });
})();

(()=>{
  if(!document.body.classList.contains('feine-pdp'))return;
  let host,root,pending=false;
  const dismiss=()=>{
    pending=false;
    const next=document.getElementById('ot-popup-shadow-container');
    if(!next)return;
    if(host!==next){host=next;new MutationObserver(schedule).observe(host,{attributes:true,attributeFilter:['style'],childList:true});}
    const shadow=host.shadowRoot;
    if(!shadow)return;
    if(root!==shadow){root=shadow;new MutationObserver(schedule).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['open']});}
    const dialog=root.querySelector('dialog[open]');
    const close=root.querySelector('button[aria-label="Close offer"]');
    if(dialog&&close){close.click();if(dialog.open)dialog.close();}
  };
  function schedule(){if(!pending){pending=true;queueMicrotask(dismiss)}}
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
  schedule();
})();

/* Legacy recap applies only to the legacy picker, never the sleeve builder. */
(()=>{
 if(!document.body.classList.contains('feine-pdp')||document.getElementById('feine-bundle'))return;
 let pending=false;
 function update(){
  pending=false;
  if(document.getElementById('feine-bundle'))return;
  const info=document.querySelector('.main-product__info-container');if(!info)return;
  const clear=()=>{const old=info.querySelector('.fne-order-state');if(old?.textContent)old.textContent='';};
  const form=info.querySelector('product-form.main-product-form form');
  const buttons=form?.querySelector('.product-form__buttons');
  const quantity=info.querySelector('quantity-breaks input[name="quantity"]:checked');
  const plan=form?.querySelector('[name="selling_plan"]:checked');
  const visibleCount=Number(quantity?.value);if([1,3,6].includes(visibleCount))document.body.dataset.fneQuantity=String(visibleCount);else delete document.body.dataset.fneQuantity;
  if(!buttons||!quantity||!plan){clear();return;}
  const count=Number(quantity.value);if(![1,3,6].includes(count)){clear();return;}
  const option=info.querySelector('quantity-breaks label[data-quantity="'+count+'"]');
  const price=option?.querySelector('.quantity-break__price')?.textContent.trim();if(!price){clear();return;}
  let summary=form.querySelector('.fne-order-state');if(!summary){summary=document.createElement('p');summary.className='fne-order-state';summary.id='fne-order-state';summary.setAttribute('role','status');summary.setAttribute('aria-live','polite');buttons.prepend(summary);}
  const text=price+' · '+count*5+' cans ('+count+' sleeve'+(count===1?'':'s')+') · '+(plan.value?'Monthly Autoship':'One-time purchase');
  if(summary.textContent!==text)summary.textContent=text;
  buttons.querySelectorAll('button').forEach(b=>{const ids=new Set((b.getAttribute('aria-describedby')||'').split(' ').filter(Boolean));ids.add(summary.id);const value=[...ids].join(' ');if(b.getAttribute('aria-describedby')!==value)b.setAttribute('aria-describedby',value)});
 }
 function schedule(){if(!pending){pending=true;requestAnimationFrame(update)}}
 document.body.addEventListener('change',schedule);new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,characterData:true});schedule();
})();

/* One viewport entrance for the formula; never a looping release/performance graphic. */
(()=>{
 if(!document.body.classList.contains('feine-pdp'))return;
 const motion=matchMedia('(prefers-reduced-motion: reduce)');
 document.querySelectorAll('.f13-formula-map').forEach(panel=>{
  if(panel.dataset.formulaMotion)return;
  let observer;
  function finish(){panel.classList.remove('is-energized');panel.dataset.formulaMotion='static';observer?.disconnect()}
  function reveal(){
   if(panel.dataset.formulaMotion)return;
   observer?.disconnect();
   if(motion.matches||document.hidden){finish();return}
   panel.dataset.formulaMotion='played';panel.classList.add('is-energized');
  }
  motion.addEventListener('change',()=>{if(motion.matches)finish()});
  document.addEventListener('visibilitychange',()=>{if(document.hidden&&panel.dataset.formulaMotion)finish()});
  if(motion.matches||!('IntersectionObserver' in window)){finish();return}
  observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting))reveal()},{threshold:.2});
  observer.observe(panel);
 });
})();

/* Activity-to-evidence links reveal the relevant study in one action. */
(()=>{
 if(!document.body.classList.contains('feine-pdp'))return;
 const target=hash=>/^#f14-evidence-[a-z]+$/.test(hash)?document.querySelector('#f8-research details'+hash):null;
 document.addEventListener('click',event=>{
  const link=event.target.closest?.('.f19-activity a[href^="#f14-evidence-"]');
  if(!link||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button>0)return;
  const study=target(link.hash);if(!study)return;
  event.preventDefault();event.stopPropagation();
  study.open=true;
  if(location.hash!==link.hash)history.pushState(null,'',link.hash);
  requestAnimationFrame(()=>{
   study.querySelector('summary')?.focus({preventScroll:true});
   window.scrollTo({top:window.scrollY+study.getBoundingClientRect().top-112,behavior:'instant'});
  });
 },true);
 function revealHash(){const study=target(location.hash);if(study)study.open=true}
 addEventListener('hashchange',revealHash);revealHash();
})();

/* Product display motion only: tap/click the pouch to pause; no added play/pause icon. */
(()=>{
 if(!document.body.classList.contains('feine-pdp')||!('IntersectionObserver' in window))return;
 const reduce=matchMedia('(prefers-reduced-motion: reduce)');
 document.querySelectorAll('.f13-formula-map .f13-pouch-ring').forEach(ring=>{
  if(ring.classList.contains('has-pouch-turn'))return;
  const control=document.createElement('button');control.type='button';control.className='f21-pouch-control';
  let visible=false,paused=false;
  function update(){
   const running=visible&&!paused&&!reduce.matches&&!document.hidden;
   ring.classList.toggle('is-turning',running);
   control.disabled=reduce.matches;
   control.setAttribute('aria-label',paused?'Resume pouch rotation':'Pause pouch rotation');
   control.title=paused?'Resume pouch rotation':'Pause pouch rotation';
  }
  control.addEventListener('click',()=>{paused=!paused;update()});
  ring.append(control);ring.classList.add('has-pouch-turn');
  new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;update()},{threshold:.25}).observe(ring);
  reduce.addEventListener('change',update);document.addEventListener('visibilitychange',update);update();
 });
})();

/* On FEINE, let the drawer own Escape cleanup before generic details handlers close it. */
(()=>{
 if(!document.body.classList.contains('feine-pdp'))return;
 window.addEventListener('keyup',event=>{
  if(event.key!=='Escape')return;
  const drawer=document.querySelector('header-drawer'),root=drawer?.mainDetailsToggle;
  if(!root||(!root.open&&!root.classList.contains('menu-opening'))||typeof drawer.closeMenuDrawer!=='function')return;
  const nested=event.target.closest?.('details');if(nested&&nested!==root)return;
  event.preventDefault();event.stopPropagation();
  const control=root.querySelector('summary');drawer.closeMenuDrawer(event,control);control?.setAttribute('aria-expanded','false');
 },true);
})();
/* A real quote supports the product gallery on desktop; same source/element on phones. */
(()=>{const quote=document.querySelector('.fnb__proof'),gallery=document.querySelector('.product__media-wrapper');if(!quote||!gallery)return;const home=document.createComment('Customer quote mobile position');quote.before(home);const mq=matchMedia('(min-width:1100px)');function place(){if(mq.matches)gallery.append(quote);else home.after(quote)}mq.addEventListener('change',place);place()})();

/* The inline closing action owns the ending; keep sticky buying UI off the footer. */
(()=>{
 if(!document.body.classList.contains('feine-pdp')||!('IntersectionObserver' in window))return;
 const end=document.querySelector('.f20-close'),footer=document.querySelector('footer');
 const visible=new Set();
 const observer=new IntersectionObserver(entries=>{
  for(const entry of entries){if(entry.isIntersecting)visible.add(entry.target);else visible.delete(entry.target)}
  document.body.classList.toggle('feine-ending-visible',visible.size>0);
 },{threshold:0});
 if(end)observer.observe(end);if(footer)observer.observe(footer);
})();
/* Editorial pack links return directly to the chooser, without a long theme animation. */
(()=>{
 if(!document.body.classList.contains('feine-pdp'))return;
 document.addEventListener('click',event=>{
  const link=event.target.closest?.('#MainContent a[href="#feine-bundle"]');
  if(!link||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button>0)return;
  const grid=document.querySelector('#feine-bundle .fnb__grid');if(!grid)return;
  event.preventDefault();event.stopImmediatePropagation();
  const button=grid.querySelector('button:not([disabled])');
  button?.focus({preventScroll:true});
  window.scrollTo({top:window.scrollY+grid.getBoundingClientRect().top-112,behavior:'instant'});
 },true);
})();
